import React from 'react';
import './loader.css';
const Loader = (props) => {
    const color = (props.color) ? props.color : '#fff';
    return (
      <div className="xloader" style={{color: color}}>...</div>
    );
};
export default Loader;